export default __webpack_public_path__ + "static/lift_b.f810f3e283581a4ddffc324dfa0f4969.svg";